export default __webpack_public_path__ + "static/media/31.6e68c5c3.png";